export const alignments = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
};
